export const MASK_TYPES_INPUT = {
    NFE: 'nfe',
    NO_SPACE: 'no_space',
    CPF: 'cpf',
    CPF_CNPJ: 'cpf/cnpj',
    CNPJ: 'cnpj',
    PHONE_NUMBER: 'phone_number',
    TEL: 'tel',
    PHONE_TEL: 'phone_number/tel',
    MONEY: 'money',
    MONEY_NEGATIVE: 'moneyWithNegative',
    LITER: 'liter',
    GENERIC: 'generic',
}

export const STATE_OPTIONS = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
    'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN',
    'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
]

export const CLIENT_TYPE = {
    PATIENT: 'PATIENT',
    PATIENT_TUTOR: 'PATIENT_TUTOR',
    PET_TUTOR: 'PET_TUTOR',
}

export const CLIENT_TYPE_OPTIONS = [
    { label: 'Paciente', value: CLIENT_TYPE.PATIENT },
    { label: 'Tutor de Paciente', value: CLIENT_TYPE.PATIENT_TUTOR },
    { label: 'Tutor de Pet', value: CLIENT_TYPE.PET_TUTOR },
];